import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    items: null,
    sellers: null,
    loginSuccess: false,
    loginError: "",
    searchBar: false
  },
  mutations: {
    SET_USER_DATA(state, userData) {
      state.user = userData;
      localStorage.setItem("user", JSON.stringify(userData));
      axios.defaults.headers.common["token"] = userData.token;
    },
    CLEAR_USER_DATA(state) {
      localStorage.removeItem("user");
      state.loginSuccess = false;
      state.loginError = "";
      location.reload();
    },
    SET_ITEMS(state, itemsJson) {
      state.items = itemsJson.items;
    },
    SET_SELLERS(state, data) {
      state.sellers = data;
      localStorage.setItem("sellers", JSON.stringify(data));
    },
    SHOW_SEARCHBAR(state, setting) {
      state.searchBar = setting;
    }
  },
  actions: {
    login({ commit }, credentials) {
      let headers = {
        headers: credentials
      };
      return axios
        .post("https://1moda.slimm.co/api/sjors/logistics/login", "", headers)
        .then(({ data }) => {
          if (data.error === 1) {
            this.state.user = null;
            this.state.loginSuccess = false;
            this.state.loginError = data.message;
          } else {
            this.state.loginSuccess = true;
            this.state.loginError = "";
            commit("SET_USER_DATA", data);
            this.dispatch("getSellersFromServer");
          }
        });
    },
    logout({ commit }) {
      commit("CLEAR_USER_DATA");
    },
    getExpectedFromServer({ commit }) {
      return axios
        .get("https://1moda.slimm.co/api/sjors/logistics")
        .then(({ data }) => {
          if (data.message == "Invalid token") {
            commit("CLEAR_USER_DATA");
          } else {
            commit("SET_ITEMS", data);
          }
        });
    },
    processExpected({ commit }, data) {
      return axios
        .post("https://1moda.slimm.co/api/sjors/logistics", {
          items: { itemid: data.itemId, qty: data.qty }
        })
        .then(({ data }) => {
          console.log(data);
          if (data.success == true) {
            this.dispatch("getExpectedFromServer");
          } else {
            commit("CLEAR_USER_DATA");
          }
        });
    },
    getSellersFromServer({ commit }) {
      return axios
        .get("https://1moda.slimm.co/api/sjors/logistics/supplierlist")
        .then(({ data }) => {
          if (data.suppliers) {
            console.log("Er zijn sellers");
            commit("SET_SELLERS", data.suppliers);
          } else {
            commit("CLEAR_USER_DATA");
            console.log("Er is iets verkeerd gegaan: " + data.message);
          }
        });
    },
    setItems({ commit }, data) {
      commit("SET_ITEMS", data);
    }
  },
  modules: {},
  getters: {
    loggedIn(state) {
      //console.log(state.user);
      return !!state.user;
    },
    getItemById: state => id => {
      return state.items.find(item => item.itemId === id);
    },
    getExpected: state => {
      if (state.items) {
        return state.items.filter(
          item => item.qty - item.qtyDelivered - item.qtyCanceled > 0
        );
      }
    },
    getSellers: state => {
      if (state.sellers && state.items) {
        let result = [];
        let sellers = state.sellers;
        let items = state.items;

        for (let i = 0; i < sellers.length; i++) {
          let qtyExpected = 0;
          for (let a = 0; a < items.length; a++) {
            if (items[a].purchase.supplier == sellers[i].id) {
              let qty =
                items[a].qty - items[a].qtyDelivered - items[a].qtyCanceled;
              if (qty > 0) {
                qtyExpected = qtyExpected + qty;
              }
            }
          }
          if (qtyExpected > 0) {
            result.push({
              id: sellers[i].id,
              name: sellers[i].name,
              qty: qtyExpected
            });
          }
        }
        return result;
      }
    },
    getExpectedBySeller: state => id => {
      return state.items.filter(
        item =>
          item.qty - item.qtyDelivered - item.qtyCanceled > 0 &&
          item.purchase.supplier == id
      );
    }
  }
});
